import React from "react";

const DashCms = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNjU1ZGQyODUtNDE2YS00NmZlLWJmNzAtNmQ0NjRjMWZjZWEwIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9&pageName=ReportSection77b34c8a807d09a8e7c1" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default DashCms;
